export function getQuestionnaireVersionLabel(questionnaireVersion?: string | null): string {
    return questionnaireVersion || '';
}
